const MAX_LABEL = 120;

export type ContactDisplayNameInput = {
  businessName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneE164?: string | null;
  email?: string | null;
  id?: string;
};

/** Nombre visible en admin: razón social, o nombre+apellido, o teléfono/email. */
export function contactDisplayName(input: ContactDisplayNameInput): string {
  const business = input.businessName?.trim() ?? '';
  if (business) {
    return business.slice(0, MAX_LABEL);
  }
  const fullName = [input.firstName?.trim(), input.lastName?.trim()].filter(Boolean).join(' ');
  if (fullName) {
    return fullName.slice(0, MAX_LABEL);
  }
  const phone = input.phoneE164?.trim() ?? '';
  if (phone) {
    return phone.slice(0, MAX_LABEL);
  }
  const email = input.email?.trim() ?? '';
  if (email) {
    return email.slice(0, MAX_LABEL);
  }
  const id = input.id?.trim() ?? '';
  return id.slice(0, MAX_LABEL);
}
